import { FormattedMessage } from 'react-intl';

import styles from './ManualCompany.module.css';
import { TextInput } from '../../../../forms/formField/Input';

type Props = {
    companyName: string;
    companyNumber: string;
    onCompanyNameChange: (value: string) => void;
    onCompanyNumberChange: (value: string) => void;
};

export const ManualCompany = ({
    companyName,
    companyNumber,
    onCompanyNameChange,
    onCompanyNumberChange
}: Props) => (
    <div className={styles.ManualCompany}>
        <div className={styles.registeredName}>
            <label htmlFor="companyName">
                <FormattedMessage
                    id="_.manualCompany.registered_name"
                    defaultMessage="Registered name"
                />
            </label>
            <TextInput
                id="companyName"
                name="companyName"
                value={companyName}
                disabled
                onChange={(e) => onCompanyNameChange(e.target.value)}
            />
        </div>
        <div className={styles.registeredNumber}>
            <label htmlFor="companyNumber">
                <FormattedMessage
                    id="_.manualCompany.registered_number"
                    defaultMessage="Registered number"
                />
            </label>
            <TextInput
                id="companyNumber"
                name="companyNumber"
                value={companyNumber}
                disabled
                onChange={(e) => onCompanyNumberChange(e.target.value)}
            />
        </div>
    </div>
);
